(function ($) {
  "use strict";
  jQuery(document).ready(function() {
    // menu toggler js
    $("button.navbar-toggle").on('click', function() {
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("ov-hidden");
    });
    $(".close-box").on('click', function() {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("ov-hidden");
    });
    // filter button js
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    // body background color js
    $(".mm-fullscreen-bg").on('click',function() {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
    $('.item-data').on("click", function() {
      $(this).parents('.option-block').find(".variant-option").removeClass('active-variant');
      $(this).closest('form-wrap').addClass('active-variant');
      var it_img = $(this).attr('dataimg');
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('src',it_img);
      $(this).parents('.single-product-wrap').find('.product-image .img1 img').attr('srcset',it_img);
      var price = $(this).attr('dataprice');
      var compareprice = $(this).attr('datacompare');
      var stocks = $(this).attr('dataavailable');
      $(this).parents('.single-product-wrap').find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $(this).parents('.single-product-wrap').find('.price-box .old-price').show();
        $(this).parents('.single-product-wrap').find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      }else{
        $(this).parents('.single-product-wrap').find('.price-box .old-price').hide();
      }
    });
    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);








// Helper: Update active class on grid-qty-box based on the input's quantity.
function updateActiveClass(input) {
  const gridBox = input.closest('grid-qty-box');
  if (!gridBox) return;
  const currentQuantity = parseInt(input.value, 10) || 0;
  if (currentQuantity > 0) {
    gridBox.classList.add('active');
  } else {
    gridBox.classList.remove('active');
  }
}


// Helper: Update max class on grid-qty-box based on the input's quantity and max.
function updateMaxClass(input) {
  const gridBox = input.closest('grid-qty-box');
  if (!gridBox) return;
  const max = parseInt(input.getAttribute('data-max'), 10) || Infinity;
  const currentQuantity = parseInt(input.value, 10) || 0;
  if (currentQuantity >= max) {
    gridBox.classList.add('max');
  } else {
    gridBox.classList.remove('max');
  }
}

// New helper: Sync the grid inputs with the current cart quantities.
function syncGridQuantities(cartData) {
  // Create a lookup: variant id => quantity
  const quantities = {};
  cartData.items.forEach(function(item) {
    quantities[item.id] = item.quantity;
  });
  // Update each grid input.
  document.querySelectorAll('.grid-qty-box-input').forEach(function(input) {
    const variantId = input.getAttribute('data-quantity-variant-id');
    if (quantities[variantId] !== undefined) {
      input.value = quantities[variantId];
    } else {
      input.value = 0;
    }
    updateActiveClass(input);
    updateMaxClass(input);
  });
}

// Plus button: Increase quantity by step and add to cart
document.addEventListener('click', function(event) {
  const plusButton = event.target.closest('button.qty-bt[name="plus"]');
  if (plusButton) {
    event.preventDefault();
    if (plusButton.getAttribute('data-handled') === 'true') return;
    plusButton.setAttribute('data-handled', 'true');

    const gridBox = plusButton.closest('grid-qty-box');
    if (!gridBox) {
      plusButton.removeAttribute('data-handled');
      return;
    }
    
    const input = gridBox.querySelector('.grid-qty-box-input');
    if (!input) {
      plusButton.removeAttribute('data-handled');
      return;
    }
    
    const variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) {
      plusButton.removeAttribute('data-handled');
      return;
    }
    
    // Get the step (default 1) and max from data attributes.
    const step = parseInt(input.getAttribute('data-step'), 10) || 1;
    const max = parseInt(input.getAttribute('data-max'), 10) || Infinity;
    
    // Increment quantity by step without exceeding max.
    let currentQuantity = parseInt(input.value, 10) || 0;
    let newQuantity = currentQuantity + step;
    if (newQuantity > max) { newQuantity = max; }
    input.value = newQuantity;
    
    updateMaxClass(input);
    updateActiveClass(input);
    
    // Calculate how many units to add.
    const quantityToAdd = newQuantity - currentQuantity;
    if (quantityToAdd <= 0) {
      plusButton.removeAttribute('data-handled');
      return;
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantityToAdd })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error adding item to cart');
      return response.json();
    })
    .then(data => {
      updateAjaxCart();
      updateCartCount();
    })
    .catch(error => console.error('Error:', error))
    .finally(() => {
      setTimeout(() => { plusButton.removeAttribute('data-handled'); }, 0);
    });
  }
});

// Minus button: Decrease quantity by step and update the cart.
// If quantity becomes 0, remove the active class.
document.addEventListener('click', function(event) {
  const minusButton = event.target.closest('button.qty-bt[name="minus"]');
  if (minusButton) {
    event.preventDefault();
    if (minusButton.getAttribute('data-handled') === 'true') return;
    minusButton.setAttribute('data-handled', 'true');

    const gridBox = minusButton.closest('grid-qty-box');
    if (!gridBox) {
      minusButton.removeAttribute('data-handled');
      return;
    }
    
    const input = gridBox.querySelector('.grid-qty-box-input');
    if (!input) {
      minusButton.removeAttribute('data-handled');
      return;
    }
    
    const variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) {
      minusButton.removeAttribute('data-handled');
      return;
    }
    
    // Get the step (default 1)
    const step = parseInt(input.getAttribute('data-step'), 10) || 1;
    
    let currentQuantity = parseInt(input.value, 10) || 0;
    let newQuantity = Math.max(currentQuantity - step, 0);
    input.value = newQuantity;
    
    updateMaxClass(input);
    updateActiveClass(input);
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQuantity })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error updating cart item');
      return response.json();
    })
    .then(data => {
      updateAjaxCart();
      updateCartCount();
    })
    .catch(error => console.error('Error updating variant quantity:', error))
    .finally(() => {
      setTimeout(() => { minusButton.removeAttribute('data-handled'); }, 0);
    });
  }
});

// Listen for manual changes on the input field
document.addEventListener('change', function(event) {
  if (event.target && event.target.matches('.grid-qty-box-input')) {
    const input = event.target;
    const variantId = input.getAttribute('data-quantity-variant-id');
    if (!variantId) return;
    
    const max = parseInt(input.getAttribute('data-max'), 10) || Infinity;
    let newQuantity = parseInt(input.value, 10) || 0;
    if (newQuantity > max) {
      newQuantity = max;
      input.value = max;
    }
    
    updateMaxClass(input);
    updateActiveClass(input);
    
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: newQuantity })
    })
    .then(response => {
      if (!response.ok) throw new Error('Error updating cart item from input');
      return response.json();
    })
    .then(data => {
      updateAjaxCart();
      updateCartCount();
    })
    .catch(error => console.error('Error updating variant quantity from input:', error));
  }
});

function updateAjaxCart() {
  fetch('/cart?view=ajax')
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContent = doc.querySelector('.drawer-inner');
      const ajaxCart = document.querySelector('ajax-cart');
      if (newContent && ajaxCart) {
        const drawerInnerMain = ajaxCart.querySelector('.drawer-inner');
        drawerInnerMain.innerHTML = newContent.innerHTML;
        if (drawerInnerMain.querySelector('.cart-item')) {
          ajaxCart.classList.remove('is-empty');
        } else {
          ajaxCart.classList.add('is-empty');
        }
      }
    })
    .catch(error => console.error('Error updating ajax cart:', error));
}

function updateCartCount() {
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) throw new Error(`Network error: ${response.status}`);
      return response.json();
    })
    .then(data => {
      const countElements = document.querySelectorAll('.ajax-cart-count');
      countElements.forEach(el => {
        el.textContent = data.item_count;
      });
      // Sync the grid inputs with the latest cart quantities.
      syncGridQuantities(data);
    })
    .catch(error => console.error('Error updating cart count:', error));
}




// On page load, fetch the cart and update quantity inputs.
document.addEventListener("DOMContentLoaded", function() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      // Build a lookup: variant id → quantity
      const cartQuantities = {};
      data.items.forEach(item => {
        cartQuantities[item.id] = item.quantity; // item.id is the variant id
      });
      // Update each grid-qty-box input
      document.querySelectorAll('.grid-qty-box-input').forEach(input => {
        const variantId = input.getAttribute('data-quantity-variant-id');
        // If this variant exists in the cart, update the input's value; otherwise, default to 0.
        input.value = cartQuantities[variantId] !== undefined ? cartQuantities[variantId] : 0;
        // Update active and max classes accordingly.
        updateActiveClass(input);
        updateMaxClass(input);
      });
    })
    .catch(error => console.error("Error fetching cart on load:", error));
});



document.addEventListener('click', function(event) {
  // Look for a click on a <delpro-btn> that has a data-variant-id attribute.
  const removeButton = event.target.closest('delpro-btn[data-variant-id]');
  if (removeButton) {
    event.preventDefault();
    
    // Retrieve the variant id from the button's data attribute.
    const variantId = removeButton.getAttribute('data-variant-id');
    if (!variantId) return;
    
    // Send an AJAX request to remove the variant from the cart by setting its quantity to 0.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 0 })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Error removing item from cart');
      }
      return response.json();
    })
    .then(data => {
      // Refresh the mini cart and cart count after removal.
      updateAjaxCart();
      updateCartCount();
    })
    .catch(error => console.error('Error removing item:', error));
  }
});